import React, { memo, SVGProps } from 'react'

export const ChevronRight = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.2048 6.8832C9.92352 6.60192 9.46752 6.60192 9.18624 6.8832C8.90496 7.16448 8.90496 7.62048 9.18624 7.90176L13.2864 12.001L9.18624 16.1002C8.90496 16.3814 8.90496 16.8374 9.18624 17.1187C9.3264 17.2589 9.51072 17.3299 9.69504 17.3299C9.87936 17.3299 10.0637 17.2598 10.2038 17.1187L14.8128 12.5107C14.9482 12.3754 15.024 12.193 15.024 12.0019C15.024 11.8109 14.9482 11.6275 14.8128 11.4931L10.2038 6.88512L10.2048 6.8832Z"
      fill="currentColor"
    />
  </svg>
))
